import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { BannerNotification } from '@frontend/design-system';

interface InsuranceCardBannerNotificationProps {
  hasCoverage: boolean;
  isAutoVerification: boolean;
  enhancedVerificationInprogress: boolean;
  isInsuranceDetailsWritebackSupported: boolean;
  isDemoOffice: boolean;
  isEligibleForWebsiteResp: boolean;
}

export const InsuranceCardBannerNotification = ({
  hasCoverage,
  isAutoVerification,
  enhancedVerificationInprogress,
  isInsuranceDetailsWritebackSupported,
  isDemoOffice,
  isEligibleForWebsiteResp,
}: InsuranceCardBannerNotificationProps) => {
  const { t } = useTranslation();
  const commonBannerStyles = { margin: theme.spacing(2, 0) };

  if (enhancedVerificationInprogress) {
    return (
      <BannerNotification
        css={commonBannerStyles}
        status='warn'
        message={t("We're currently retrieving your report. This may take 1-2 minutes.")}
      />
    );
  }

  if (isEligibleForWebsiteResp) {
    return (
      <BannerNotification
        css={commonBannerStyles}
        status='info'
        message={t(
          'You’re eligible for enhanced data. Update connection settings to access more detailed insurance report.'
        )}
      />
    );
  }

  if (hasCoverage) {
    if (isAutoVerification) {
      return (
        <BannerNotification
          css={commonBannerStyles}
          status='success'
          message={t('EHR data was used to successfully verify the information')}
        />
      );
    } else {
      const shouldShowSimpleSuccessMessage = isInsuranceDetailsWritebackSupported || isDemoOffice;
      const status = shouldShowSimpleSuccessMessage ? 'success' : 'info';
      const message = shouldShowSimpleSuccessMessage
        ? t('Verification successful.')
        : t('Verification successful. However, updated insurance data will not be synced with the EHR.');
      return <BannerNotification css={commonBannerStyles} status={status} message={message} />;
    }
  }

  return null;
};
